// Utilities
import { make } from 'vuex-pathify';
import { toggle } from '../utils';
const DEFAULT_RIGHTNAVDATA = Object.freeze({
  color: 'primary',
  href: false,
  msg: '',
  text: 'Close',
  to: false,
  timeout: 6000,
  action: function() {}
});

export const state = {
  currentVersion: process.env.VUE_APP_VERSION,
  companyName: 'Jamesway',
  miniCompanyImage: require('@/assets/logos/jamesway_mini_logo.png'),
  lightCompanyImage: require('@/assets/logos/jamesway_logo.png'),
  darkCompanyImage: require('@/assets/logos/jamesway_logo.png'),
  airwayIcon: require('@/assets/logos/airway_icon.png'),
  jameswayEggIcon: require('@/assets/logos/jamesway_egg_icon.png'),
  chickmasterEggIcon: require('@/assets/logos/chickmaster_egg_icon.png'),
  links: require('@/data/drawerItems.json'),
  drawer: true as boolean,
  mini: false as boolean,
  loading: false as boolean,
  rightDrawer: false as boolean,
  isLoading: false as boolean,
  releases: [],
  rightNavData: {
    ...DEFAULT_RIGHTNAVDATA
  },
  eventDialog: false as boolean
};

export const mutations = {
  ...make.mutations(state),
  TOGGLE_EVENT_DIALOG: toggle('eventDialog'),
  setRightNavData: (state: any, payload: object) => {
    state.rightNavData = Object.assign({}, DEFAULT_RIGHTNAVDATA, payload);
  }
};

export const actions = {
  setDrawer: async ({ commit }: any, payload: boolean) => {
    commit('SET_DRAWER', payload);
  },

  setRightDrawer: async ({ commit }: any, payload: boolean) => {
    commit('SET_RIGHT_DRAWER', payload);
  }
};

export const getters = { ...make.getters(state) };
